import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section } from '../Section';
import { RouteFlow } from '../RouteFlow';
import { TransformCTA } from '../TransformCTA';
const option1 = ['Open another guideline.', 'Search another reference.', 'Cross-reference information.', 'Try to connect the pieces.', 'And hope you’ve found what you need before the consultation moves on.'];
const option2 = ['Identify the clinical scenario.', 'Open the appropriate route.', 'Review the structured decision points.', 'Organize the next steps.', 'Determine what needs monitoring and follow-up.'];
export function TwoOptions() {
  return <Section tone="ink" eyebrow="Two options" title="The next time a patient presents with a renal question, you have two options." data-id="element-280" data-mp="tancpv1eov2x">
      <div className="grid gap-4 lg:grid-cols-2" data-id="element-281" data-mp="2v568a3rnicwt">
        <div className="rounded-3xl border border-white/12 bg-white/[0.04] p-5 sm:p-7" data-id="element-282" data-mp="2v6hbo2h6pine">
          <div className="flex items-center gap-2.5" data-id="element-283" data-mp="2z7ssbii2ytjg">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#b3261e]" data-id="element-284" data-mp="lb48m2yiinmi">
              <XIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-285" data-mp="gib4nhavbjbh" />
            </span>
            <h3 className="font-display text-xl font-bold text-white" data-id="element-286" data-mp="bjgchor0giep">
              Option 1
            </h3>
          </div>
          <p className="mt-3 text-[15px] font-semibold text-white/85" data-id="element-287" data-mp="6mpwf1f7hmta">
            Continue searching through multiple resources.
          </p>
          <ul className="mt-4 space-y-2" data-id="element-288" data-mp="z9u4xgdicj9t">
            {option1.map(item => <li key={item} className="text-[14px] leading-relaxed text-white/60" data-id="element-289" data-mp="z7r92fpobvx6">
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border border-cta/40 bg-cta/10 p-5 sm:p-7" data-id="element-290" data-mp="3f0yjxv2vfnel">
          <div className="flex items-center gap-2.5" data-id="element-291" data-mp="3eyvj0g06k9v3">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cta" data-id="element-292" data-mp="3a0tz5suxk6ik">
              <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-293" data-mp="2226fj8wzxi7r" />
            </span>
            <h3 className="font-display text-xl font-bold text-white" data-id="element-294" data-mp="264b59wkbpup4">
              Option 2
            </h3>
          </div>
          <p className="mt-3 text-[15px] font-semibold text-white" data-id="element-295" data-mp="1s3gxng53nxri">
            Open Renal Decision Desk™.
          </p>
          <ul className="mt-4 space-y-2.5" data-id="element-296" data-mp="1x5fzgll6ymmc">
            {option2.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-297" data-mp="1icw1s0gt97ca">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-298" data-mp="1n5fbgmcdnibt" />
                <span className="text-[14px] leading-relaxed text-white/85" data-id="element-299" data-mp="19bo1xdynbyg3">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-9" data-id="element-300" data-mp="zgculgpkhtid">
        <RouteFlow tone="dark" steps={['Finding', 'Assessment', 'Decision', 'Action', 'Monitoring', 'Follow-up / Referral']} data-id="element-301" data-mp="14eo41qbya202" />
      </div>

      <p className="mx-auto mt-8 max-w-2xl text-center font-display text-[22px] font-bold leading-snug text-white sm:text-3xl" data-id="element-302" data-mp="gsvcvw4gu13k">
        You don’t need more information. You need a route.
      </p>

      <TransformCTA tone="dark" label="Yes — I want Renal Decision Desk™" sub="Instant digital access • One-time payment • Lifetime access • 7-day guarantee" data-id="element-303" data-mp="pqe2zewyv5mb" />
    </Section>;
}